import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAgent } from '../../../models/agents.models';
@Component({
  selector: 'app-new-agent-portfolio',
  templateUrl: './new-agent-portfolio.component.html',
  styleUrls: ['./new-agent-portfolio.component.scss'],
})
export class NewAgentPortfolioComponent implements OnInit {
  @Input() agent!: IAgent;
  @Output() nextStep = new EventEmitter();
  @Output() previousStep = new EventEmitter();

  selectedLocations: number[] = [];

  constructor() {}

  async ngOnInit(): Promise<void> {

    if (this.agent && this.agent.location_ids)
      this.selectedLocations = this.agent.location_ids;
  }

  selectedLocationsChange(locations: number[]) {
    this.selectedLocations = locations;
  }

  next(options: { skip: boolean } = { skip: false }) {
    this.nextStep.emit(
      options.skip
        ? { location_ids: [] }
        : { location_ids: this.selectedLocations }
    );
  }

  previous() {
    this.previousStep.emit({ location_ids: this.selectedLocations });
  }
}
